<div style="height: 500px;">
	<div *ngIf="isLoaded$| async">
		<detailed-grid-form #source [formGroup]="sourceFormGroup" [dataSource]="sourceFunctionAppList$ | async" appName="Source" [selectedFunctionAppItemId]="selectedSourceFunctionApp" [link]="link"></detailed-grid-form>
		<detailed-grid-form #target [formGroup]="targetFormGroup" [dataSource]="targetFunctionAppList$ | async" appName="Target" [selectedFunctionAppItemId]="selectedTargetFunctionApp" [link]="link"></detailed-grid-form>
		<detailed-grid-form #global [formGroup]="globalFormGroup" [dataSource]="globalFunctionAppList$ | async" appName="Global" [selectedFunctionAppItemId]="selectedGlobalFunctionApp" [link]="link"></detailed-grid-form>
		<detailed-grid-form #entrypoint [formGroup]="entryPointFormGroup" [dataSource]="entryPointFunctionAppList$ | async" appName="Entry point" [selectedFunctionAppItemId]="selectedEntryPointFunctionApp" [link]="link"></detailed-grid-form>
	</div>

	<button type="button" class="btn btn-primary btn-sm" (click)="updateFunctionAppLinkConfiguration()">
    Update link function app configuration
  </button>
</div>
